<template>
  <!-- <div class="kye-dialog-body layout-img-dialog">
    <img :src="dialogData.iconUrlNew" alt="" @click="onClick">
  </div> -->
  <el-dialog :title="dialogData.name" :visible.sync="visible" class="layout-img-dialog" width="850px" :canResize="false" :showFullScreenButton="false">
    <div class="kye-dialog-body">
      <img :src="dialogData.iconUrlNew" alt="" @click="onClick">
    </div>
  </el-dialog>
</template>

<script>
  import {handleJumpTo} from './utils'
  export default {
    // props: {
    //   dialogData: Object
    // },
    data() {
      return {
        dialogData: {},
        visible: false
      }
    },
    methods: {
      open (val) {
        this.dialogData = val
        this.visible = true
      },
      onClick () {
        // 上报反馈数据
        // updateFeedback(this.dialogData)
        this.$emit('updateFeedback')
        // 跳转
        handleJumpTo(this.dialogData)
      }
    }
  }
</script>

<style lang="scss" scoped>
.layout-img-dialog {
  img {
    display: block;
    width: 100%;
    cursor: pointer;
  }
}
</style>



// WEBPACK FOOTER //
// src/layout/pages/home/banner/img-dialog.vue